import { useQuery } from "@tanstack/react-query";

import { dutySchedulesApi } from "@/api";
import { QueryKey } from "@/query/Query";

/**
 * Everything the "Verteilung AW / BG" tab renders: the current plan's per-counselor rows, the
 * Periodenvergleich against previously freigegebene Dienstpläne, and the Kennzahlen — all computed
 * backend-side so the per-counselor and period-total duty counts cannot drift apart.
 */
export function useDutyScheduleDistributionSummary(id: string | undefined) {
  const {
    data: distributionSummary,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [QueryKey.DutyScheduleDistributionSummary, id],
    // The route cannot match without an id; the fallback only satisfies the type.
    queryFn: () => dutySchedulesApi.getDutyScheduleDistributionSummary({ id: id ?? "" }),
    enabled: id != null,
  });

  return { distributionSummary, isLoading, isError };
}
